import { createMachine, assign } from '@xstate/fsm';
const calculateSubtotal = (embroideryData)=>{
    return (context)=>{
        void context;
        if (embroideryData === null) {
            return 0;
        }
        let subtotal = 0;
        if (embroideryData.embroidery_product.price) {
            subtotal += parseFloat(embroideryData.embroidery_product.price);
        }
        if (embroideryData.current_variant.price) {
            subtotal += parseFloat(embroideryData.current_variant.price);
        }
        return subtotal;
    };
};
const sanitizeMonogramByFontStyle = (monogramText, fontStyle)=>{
    if (fontStyle.includes('Quimby') || fontStyle.includes('Peridot')) {
        return monogramText.toUpperCase();
    }
    return monogramText.toLowerCase();
};
var _embroideryData_placements__options__limit;
const createInitialState = (embroideryData)=>{
    var _embroideryData_colors_, _embroideryData_colors_1, _embroideryData_placements__options_, _embroideryData_placements_;
    return {
        currentStep: 0,
        selectedPlacement: '',
        selectedFontCategory: '',
        selectedFontStyle: '',
        selectedFontSize: '',
        selectedColorName: embroideryData && ((_embroideryData_colors_ = embroideryData.colors[0]) === null || _embroideryData_colors_ === void 0 ? void 0 : _embroideryData_colors_.storefrontColorName),
        hexColor: embroideryData && ((_embroideryData_colors_1 = embroideryData.colors[0]) === null || _embroideryData_colors_1 === void 0 ? void 0 : _embroideryData_colors_1.hexColor),
        positionX: 0,
        positionY: 0,
        rotation: 0,
        alignment: 'center',
        indexPlacement: 0,
        monogramText: '',
        showPlacementGuide: false,
        isFormValid: false,
        placements: embroideryData && embroideryData.placements || [],
        indexOption: 0,
        subtotal: 0,
        embroideryData: embroideryData,
        limit: (_embroideryData_placements__options__limit = (_embroideryData_placements__options_ = (_embroideryData_placements_ = embroideryData === null || embroideryData === void 0 ? void 0 : embroideryData.placements[0]) === null || _embroideryData_placements_ === void 0 ? void 0 : _embroideryData_placements_.options[0]) === null || _embroideryData_placements__options_ === void 0 ? void 0 : _embroideryData_placements__options_.limit) !== null && _embroideryData_placements__options__limit !== void 0 ? _embroideryData_placements__options__limit : 0
    };
};
export const createEmbroideryMachine = (embroideryData)=>{
    const initialState = createInitialState(embroideryData);
    const subtotalCalculator = calculateSubtotal(embroideryData);
    // Common actions that work across all states
    const commonActions = {
        SET_PLACEMENT: {
            target: 'step1',
            actions: assign((context, event)=>{
                var _context_embroideryData, _context_embroideryData_text_configurations, _context_embroideryData_text_configurations_event_index, _context_embroideryData1, _context_embroideryData_text_configurations1, _context_embroideryData_text_configurations_event_index1, _context_embroideryData2, _context_embroideryData_text_configurations2, _context_embroideryData_text_configurations_event_index2, _context_embroideryData3, _context_embroideryData_text_configurations3, _context_embroideryData_text_configurations_event_index3;
                var _context_embroideryData_text_configurations_event_index_position_x, _context_embroideryData_text_configurations_event_index_position_y, _context_embroideryData_text_configurations_event_index_rotation, _context_embroideryData_text_configurations_event_index_alignment;
                const newContext = {
                    ...initialState,
                    selectedPlacement: event.value,
                    positionX: (_context_embroideryData_text_configurations_event_index_position_x = (_context_embroideryData = context.embroideryData) === null || _context_embroideryData === void 0 ? void 0 : (_context_embroideryData_text_configurations = _context_embroideryData.text_configurations) === null || _context_embroideryData_text_configurations === void 0 ? void 0 : (_context_embroideryData_text_configurations_event_index = _context_embroideryData_text_configurations[event.index]) === null || _context_embroideryData_text_configurations_event_index === void 0 ? void 0 : _context_embroideryData_text_configurations_event_index.position_x) !== null && _context_embroideryData_text_configurations_event_index_position_x !== void 0 ? _context_embroideryData_text_configurations_event_index_position_x : 0,
                    positionY: (_context_embroideryData_text_configurations_event_index_position_y = (_context_embroideryData1 = context.embroideryData) === null || _context_embroideryData1 === void 0 ? void 0 : (_context_embroideryData_text_configurations1 = _context_embroideryData1.text_configurations) === null || _context_embroideryData_text_configurations1 === void 0 ? void 0 : (_context_embroideryData_text_configurations_event_index1 = _context_embroideryData_text_configurations1[event.index]) === null || _context_embroideryData_text_configurations_event_index1 === void 0 ? void 0 : _context_embroideryData_text_configurations_event_index1.position_y) !== null && _context_embroideryData_text_configurations_event_index_position_y !== void 0 ? _context_embroideryData_text_configurations_event_index_position_y : 0,
                    rotation: (_context_embroideryData_text_configurations_event_index_rotation = (_context_embroideryData2 = context.embroideryData) === null || _context_embroideryData2 === void 0 ? void 0 : (_context_embroideryData_text_configurations2 = _context_embroideryData2.text_configurations) === null || _context_embroideryData_text_configurations2 === void 0 ? void 0 : (_context_embroideryData_text_configurations_event_index2 = _context_embroideryData_text_configurations2[event.index]) === null || _context_embroideryData_text_configurations_event_index2 === void 0 ? void 0 : _context_embroideryData_text_configurations_event_index2.rotation) !== null && _context_embroideryData_text_configurations_event_index_rotation !== void 0 ? _context_embroideryData_text_configurations_event_index_rotation : 0,
                    alignment: (_context_embroideryData_text_configurations_event_index_alignment = (_context_embroideryData3 = context.embroideryData) === null || _context_embroideryData3 === void 0 ? void 0 : (_context_embroideryData_text_configurations3 = _context_embroideryData3.text_configurations) === null || _context_embroideryData_text_configurations3 === void 0 ? void 0 : (_context_embroideryData_text_configurations_event_index3 = _context_embroideryData_text_configurations3[event.index]) === null || _context_embroideryData_text_configurations_event_index3 === void 0 ? void 0 : _context_embroideryData_text_configurations_event_index3.alignment) !== null && _context_embroideryData_text_configurations_event_index_alignment !== void 0 ? _context_embroideryData_text_configurations_event_index_alignment : 'center',
                    indexPlacement: context.placements.findIndex((placement)=>placement.label === event.value)
                };
                return {
                    ...newContext,
                    subtotal: subtotalCalculator(newContext)
                };
            })
        },
        TOGGLE_PLACEMENT_GUIDE: {
            actions: assign((context)=>({
                    ...context,
                    showPlacementGuide: !context.showPlacementGuide
                }))
        }
    };
    return createMachine({
        id: 'embroidery',
        initial: 'step0',
        context: initialState,
        states: {
            step0: {
                on: {
                    ...commonActions,
                    NEXT_STEP: {
                        target: 'step1',
                        cond: (context)=>context.selectedPlacement !== null
                    }
                },
                entry: assign((context)=>({
                        ...context,
                        currentStep: 0,
                        subtotal: subtotalCalculator(context)
                    }))
            },
            step1: {
                on: {
                    ...commonActions,
                    NEXT_STEP: {
                        target: 'step2',
                        cond: (context)=>context.selectedFontCategory !== null
                    },
                    PREV_STEP: 'step0',
                    SET_FONT_CATEGORY: {
                        actions: assign((context, event)=>{
                            return {
                                ...context,
                                selectedFontCategory: event.value,
                                indexOption: event.index,
                                limit: event.limit
                            };
                        })
                    }
                },
                entry: assign((context)=>({
                        ...context,
                        currentStep: 1,
                        subtotal: subtotalCalculator(context)
                    }))
            },
            step2: {
                on: {
                    ...commonActions,
                    PREV_STEP: 'step1',
                    SET_FONT_CATEGORY: {
                        actions: assign((context, event)=>{
                            return {
                                ...context,
                                selectedFontCategory: event.value,
                                indexOption: event.index,
                                limit: event.limit
                            };
                        })
                    },
                    SET_FONT_STYLE: {
                        actions: assign((context, event)=>{
                            return {
                                ...context,
                                selectedFontStyle: event.value,
                                monogramText: sanitizeMonogramByFontStyle(context.monogramText, event.value)
                            };
                        })
                    },
                    SET_FONT_SIZE: {
                        actions: assign((context, event)=>{
                            return {
                                ...context,
                                selectedFontSize: event.value
                            };
                        })
                    },
                    SET_COLOR: {
                        actions: assign((context, event)=>({
                                ...context,
                                selectedColorName: event.storefrontColorName,
                                hexColor: event.hexColor
                            }))
                    },
                    SET_MONOGRAM_TEXT: {
                        actions: assign((context, event)=>{
                            return {
                                ...context,
                                monogramText: sanitizeMonogramByFontStyle(event.value, context.selectedFontStyle)
                            };
                        })
                    },
                    TOGGLE_PLACEMENT_GUIDE: {
                        actions: assign({
                            showPlacementGuide: (context)=>!context.showPlacementGuide
                        })
                    },
                    TOGGLE_FORM_VALIDITY: {
                        actions: assign((context, event)=>({
                                ...context,
                                isFormValid: event.value
                            }))
                    }
                },
                entry: assign((context)=>({
                        ...context,
                        currentStep: 2,
                        subtotal: subtotalCalculator(context)
                    }))
            }
        }
    });
};
